<template>
  <div class="page14">
    <div class="wrapper">
      <Section1 />
      <Section2 />
      <!-- <Section3 /> -->
      <Section4 />
      <Section5 />
      <Section />
      <contacto />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Section from "@/components/practica/page14/Section";
import Section1 from "@/components/practica/page14/Section1";
import Section2 from "@/components/practica/page14/Section2";
// import Section3 from "@/components/practica/page14/Section3";
import Section4 from "@/components/practica/page14/Section4";
import Section5 from "@/components/practica/page14/Section5";
import contacto from "@/components/utils/Contacto";

export default {
    name: "Page14",
    components: {
        Section
        , Section1
        , Section2
        // , Section3
        , Section4
        , Section5
        , contacto
    },
    mounted() {
        this.$i18n.locale = "es";
    }, 
    head: {
        title: {
            inner: "Contratar seguro para estudiantes y becarios"
        },
    }
};
</script>